import styled from 'styled-components';
import { connect } from 'react-redux';
import { GhostButtonDarkTheme, theme } from '../../elements';
import { selectPreviousPage } from '../../selectors/routing';

const CtaStyledBackButton = styled(GhostButtonDarkTheme)`
  margin: 0;
  background: transparent;
  border: 1px solid ${theme.colors.neutral.light};
  color: ${theme.colors.neutral.regular};
  box-shadow: none;
`;

interface ButtonProps {
  disabled?: boolean;
  previousPage: string | null;
  dispatch: (action: { type: string }) => void;
}

const PreviousPageButton = ({ disabled, previousPage, dispatch }: ButtonProps) => {
  return (
    <CtaStyledBackButton
      data-cy="previous-button"
      onClick={() => previousPage && dispatch({ type: previousPage })}
      full={false}
      disabled={disabled || !previousPage}
    >
      Back
    </CtaStyledBackButton>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  previousPage: selectPreviousPage(state),
});

export default connect(mapStateToProps)(PreviousPageButton);
